// extracted by mini-css-extract-plugin
module.exports = {"container":"Snackbar_container__16IVC","customLoader":"Snackbar_customLoader__2sZwB","d7":"Snackbar_d7__3_4br","alertCloseIcon":"Snackbar_alertCloseIcon__3Yph2"};